import { modal } from "./modules/_modal";
modal();

/**
 *
 * Special Education Teachers - ?professionCode=100&expertiseCodes=922
 * School SLP - ?professionCode=91&expertiseCodes=666
 * School OT - ?professionCode=91&expertiseCodes=639
 * School Psychologist - ?professionCode=100&expertiseCodes=917
 * School Nurse - ?professionCode=1&professionCode=2&professionCode=5&expertiseCodes=1406&expertiseCodes=260&expertiseCodes=930&expertiseCodes=931
 * Other School jobs - ?professionCode=91&professionCode=100&professionCode=29&professionCode=1&professionCode=2&professionCode=5&expertiseCodes=677&expertiseCodes=675&expertiseCodes=639&expertiseCodes=685&expertiseCodes=648&expertiseCodes=657&expertiseCodes=910&expertiseCodes=925&expertiseCodes=1408&expertiseCodes=1409&expertiseCodes=911&expertiseCodes=1410&expertiseCodes=1254&expertiseCodes=913&expertiseCodes=1321&expertiseCodes=1416&expertiseCodes=1417&expertiseCodes=916&expertiseCodes=933&expertiseCodes=1342&expertiseCodes=1198&expertiseCodes=1414&expertiseCodes=1412&expertiseCodes=1415&expertiseCodes=1418&expertiseCodes=1419&expertiseCodes=1346&expertiseCodes=1422&expertiseCodes=1423&expertiseCodes=1426&expertiseCodes=1420&expertiseCodes=1425&expertiseCodes=924&expertiseCodes=923&expertiseCodes=919&expertiseCodes=918&expertiseCodes=1407&expertiseCodes=1411&expertiseCodes=1413&expertiseCodes=915&expertiseCodes=1421&expertiseCodes=920&expertiseCodes=921&expertiseCodes=1199&expertiseCodes=912&expertiseCodes=914&expertiseCodes=1424
 *
 */

if (document.querySelector(".featured-jobs")) {
  //
  //
  // /**
  //  *
  //  * Variables
  //  *
  //  */
  //
  let jobsData = [],
    specialEducationJobs,
    schoolPsychologistJobs,
    schoolSLPJobs,
    schoolNurseJobs,
    moreSchoolJobs,
    schoolOTJobs,
    apiUrl;
  //
  // Environment and API variables
  const coreApi = document.querySelector("html").dataset.core || `api`;
  const env = coreApi.replace("api", "www");

  apiUrl = `https://${coreApi}.ayahealthcare.com/AyaEducationWeb/job/search`;
  //
  let specialEducationEndpoint =
      apiUrl +
      "?professionCode=100&expertiseCodes=922&IncludeRelatedSpecialties=false&limit=10&offset=0",
    schoolPsychologistEndpoint =
      apiUrl +
      "?professionCode=100&expertiseCodes=917&IncludeRelatedSpecialties=false&limit=10&offset=0",
    schoolSLPEndpoint =
      apiUrl +
      "?professionCode=91&expertiseCodes=666&IncludeRelatedSpecialties=false&limit=10&offset=0",
    schoolOTEndpoint =
      apiUrl +
      "?professionCode=91&expertiseCodes=639&IncludeRelatedSpecialties=false&limit=10&offset=0",
    schoolNurseEndpoint =
      apiUrl +
      "?professionCode=1&professionCode=2&professionCode=5&expertiseCodes=1406&expertiseCodes=260&expertiseCodes=930&expertiseCodes=931&IncludeRelatedSpecialties=false&limit=10&offset=0",
    moreSchoolEndpoint =
      apiUrl +
      "?professionCode=91&professionCode=100&professionCode=29&professionCode=1&professionCode=2&professionCode=5&expertiseCodes=677&expertiseCodes=675&expertiseCodes=639&expertiseCodes=685&expertiseCodes=648&expertiseCodes=657&expertiseCodes=910&expertiseCodes=925&expertiseCodes=1408&expertiseCodes=1409&expertiseCodes=911&expertiseCodes=1410&expertiseCodes=1254&expertiseCodes=913&expertiseCodes=1321&expertiseCodes=1416&expertiseCodes=1417&expertiseCodes=916&expertiseCodes=933&expertiseCodes=1342&expertiseCodes=1198&expertiseCodes=1414&expertiseCodes=1412&expertiseCodes=1415&expertiseCodes=1418&expertiseCodes=1419&expertiseCodes=1346&expertiseCodes=1422&expertiseCodes=1423&expertiseCodes=1426&expertiseCodes=1420&expertiseCodes=1425&expertiseCodes=924&expertiseCodes=923&expertiseCodes=919&expertiseCodes=918&expertiseCodes=1407&expertiseCodes=1411&expertiseCodes=1413&expertiseCodes=915&expertiseCodes=1421&expertiseCodes=920&expertiseCodes=921&expertiseCodes=1199&expertiseCodes=912&expertiseCodes=914&expertiseCodes=1424&IncludeRelatedSpecialties=false&limit=10&offset=0";

  /**
   *
   * Get the data!
   *
   */
  async function getData() {
    // Fetch the data but return null if there's an error
    const responses = await Promise.all([
      fetch(specialEducationEndpoint),
      fetch(schoolPsychologistEndpoint),
      fetch(schoolSLPEndpoint),
      fetch(schoolNurseEndpoint),
      fetch(moreSchoolEndpoint),
      fetch(schoolOTEndpoint),
    ]);

    specialEducationJobs = await responses[0].json().catch((error) => {
      return null;
    });

    schoolPsychologistJobs = await responses[1].json().catch((error) => {
      return null;
    });

    schoolSLPJobs = await responses[2].json().catch((error) => {
      return null;
    });

    schoolNurseJobs = await responses[3].json().catch((error) => {
      return null;
    });

    moreSchoolJobs = await responses[4].json().catch((error) => {
      return null;
    });

    schoolOTJobs = await responses[5].json().catch((error) => {
      return null;
    });
  }

  /**
   *
   * Renders the results after getting the job deets
   *
   */
  async function renderResults() {
    await getData();

    let jobs = jobsData.items;

    // If something went wrong and we set the deets to null then get out
    if (specialEducationJobs == null) {
      document.querySelector(".featured-jobs").classList.add("hide-el");
      return;
    }

    if (document.querySelector("#results-container-special-education-teacher")) {
      generateMarkup(specialEducationJobs.items, "results-container-special-education-teacher");
    }
    
    if (document.querySelector("#results-container-school-psychologist")) {
      generateMarkup(schoolPsychologistJobs.items, "results-container-school-psychologist");
    }
    
    if (document.querySelector("#results-container-school-slp")) {
      generateMarkup(schoolSLPJobs.items, "results-container-school-slp");
    }
    
    if (document.querySelector("#results-container-school-ot")) {
      generateMarkup(schoolOTJobs.items, "results-container-school-ot");
    }
    
    if (document.querySelector("#results-container-school-nurse")) {
      generateMarkup(schoolNurseJobs.items, "results-container-school-nurse");
    }
    
    if (document.querySelector("#results-container-other-school")) {
      generateMarkup(moreSchoolJobs.items, "results-container-other-school");
    }
    
  }

  /**
   *
   * Slugify job details
   *
   */
  const makeSlug = (str) => {
    if (str) {
      str = str.toLowerCase();
      str = str.replace(/[^a-z0-9]+/g, "-");
      str = str.replace(/^-+|-+$/g, "");
      return str;
    }
    return "";
  };

  /**
   *
   * Generate html markup
   *
   */
  function generateMarkup(jobs, elContainer) {
    let jobsMarkup = ``;
    // let caption = '';
    let counter = 1;
    jobs.forEach((job) => {
      let jobLocation = ``;

      if (job.city && job.state) {
        jobLocation = `${job.city}, ${job.state}`;
      } else if (job.state && job.state) {
        jobLocation = `${job.state}`;
      }

      let regularPayLow = parseInt(job.regularPayLow);
      let regularPayHigh = parseInt(job.regularPayHigh);
      let customPayShift = job.customPayShift;
      let transparentPay = job.payRate.value;
      // if (customPayShift) {
      //   transparentPay = customPayShift;
      // } else if (regularPayLow == regularPayHigh) {
      //   transparentPay =
      //     regularPayHigh.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) + "/shift";
      // } else if (job.payPeriodTypeId == 2) {
      //   transparentPay =
      //     regularPayLow.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     " - " +
      //     regularPayHigh.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     "/day";
      // } else if (job.payPeriodTypeId == 1) {
      //   transparentPay =
      //     regularPayLow.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     " - " +
      //     regularPayHigh.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     "/wk";
      // } else if (
      //   job.employmentTypeCode == 7 ||
      //   job.employmentTypeCode == 8 ||
      //   job.employmentTypeCode == 1
      // ) {
      //   transparentPay =
      //     regularPayLow.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     " - " +
      //     regularPayHigh.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     "/hr";
      // } else {
      //   transparentPay =
      //     regularPayLow.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     " - " +
      //     regularPayHigh.toLocaleString("en-US", {
      //       style: "currency",
      //       currency: "USD",
      //       minimumFractionDigits: 0
      //     }) +
      //     "/wk";
      // }

      let thisExpertiseText = job.expertiseDisplayText;
      let thisProfessionText = job.professionDisplayText;

      let professionSlug = makeSlug(thisProfessionText);
      let expertiseSlug = makeSlug(thisExpertiseText);
      let citySlug = makeSlug(job.city);
      let stateSlug = makeSlug(job.state);

      const profText = `${thisProfessionText} Job`;

      const professionAndExpertise =
        professionSlug === expertiseSlug
          ? professionSlug
          : `${professionSlug}-${expertiseSlug}`;

      if (jobLocation && counter <= 6) {
        jobsMarkup += `<tr class="card mb-3" data-id="${job.jobID}">`;
        jobsMarkup += `   <th class="job job-title" scope="row">`;
        jobsMarkup += `       <h2><a href="https://${env}.ayaeducation.com/job/school-${professionAndExpertise}-${citySlug}-${stateSlug}/${job.jobID}/" target="_blank">${profText}</a></h2>`;
        jobsMarkup += `   </th>`;
        jobsMarkup += `   <td class="job job-category">`;
        jobsMarkup += `       <h3>${thisExpertiseText}</h3>`;
        jobsMarkup += `   </td>`;
        jobsMarkup += `   <td class="job job-location">`;
        jobsMarkup += `       <h3>${jobLocation}</h3>`;
        jobsMarkup += `   </td>`;
        jobsMarkup += `   <td class="job job-pay">`;
        jobsMarkup += `       <h3>${transparentPay}</h3>`;
        jobsMarkup += `   </td>`;
        jobsMarkup += `   <td class="job job-apply">`;
        jobsMarkup += `       <a href="https://${env}.ayaeducation.com/job/school-${professionAndExpertise}-${citySlug}-${stateSlug}/${job.jobID}/" class="btn primary" target="_blank">Apply</a>`;
        jobsMarkup += `   </td>`;
        jobsMarkup += `</tr>`;
        counter += 1;
      }
    });

    document.querySelector(`#${elContainer} tbody`).innerHTML = jobsMarkup;
  }

  renderResults();
}




const iframes = document.querySelectorAll("#content iframe");
iframes.forEach((i) => {
  i.parentElement.classList.add("embed-container");
});

const scrollTopBtn = document.querySelector(".scroll-to-top");
window.addEventListener("scroll", () => {
  scrollTopBtn.classList.remove("show");
  if (window.scrollY > 1000) {
    scrollTopBtn.classList.add("show");
  }
});
scrollTopBtn.addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
